/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CookiesSettingVO } from '../model';
// @ts-ignore
import { FooterInfoVO } from '../model';
// @ts-ignore
import { HelpVO } from '../model';
// @ts-ignore
import { OptionsVO } from '../model';
/**
 * SettingsControllerApi - axios parameter creator
 * @export
 */
export const SettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCookiesInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rzpv/cookies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterInfo: async (idPlanVerze: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'idPlanVerze' is not null or undefined
            assertParamExists('getFooterInfo', 'idPlanVerze', idPlanVerze)
            const localVarPath = `/api/rzpv/footer/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idPlanVerze !== undefined) {
                localVarQueryParameter['idPlanVerze'] = idPlanVerze;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHelp: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rzpv/navbar/help`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavbarOptions: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/rzpv/navbar/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingsControllerApi - functional programming interface
 * @export
 */
export const SettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCookiesInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CookiesSettingVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCookiesInfo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFooterInfo(idPlanVerze: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FooterInfoVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFooterInfo(idPlanVerze, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHelp(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHelp(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNavbarOptions(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OptionsVO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNavbarOptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingsControllerApi - factory interface
 * @export
 */
export const SettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCookiesInfo(options?: any): AxiosPromise<CookiesSettingVO> {
            return localVarFp.getCookiesInfo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} idPlanVerze 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFooterInfo(idPlanVerze: number, options?: any): AxiosPromise<FooterInfoVO> {
            return localVarFp.getFooterInfo(idPlanVerze, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHelp(options?: any): AxiosPromise<HelpVO> {
            return localVarFp.getHelp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNavbarOptions(options?: any): AxiosPromise<OptionsVO> {
            return localVarFp.getNavbarOptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingsControllerApi - interface
 * @export
 * @interface SettingsControllerApi
 */
export interface SettingsControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    getCookiesInfo(options?: any): AxiosPromise<CookiesSettingVO>;

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    getFooterInfo(idPlanVerze: number, options?: any): AxiosPromise<FooterInfoVO>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    getHelp(options?: any): AxiosPromise<HelpVO>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApiInterface
     */
    getNavbarOptions(options?: any): AxiosPromise<OptionsVO>;

}

/**
 * SettingsControllerApi - object-oriented interface
 * @export
 * @class SettingsControllerApi
 * @extends {BaseAPI}
 */
export class SettingsControllerApi extends BaseAPI implements SettingsControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public getCookiesInfo(options?: any) {
        return SettingsControllerApiFp(this.configuration).getCookiesInfo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} idPlanVerze 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public getFooterInfo(idPlanVerze: number, options?: any) {
        return SettingsControllerApiFp(this.configuration).getFooterInfo(idPlanVerze, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public getHelp(options?: any) {
        return SettingsControllerApiFp(this.configuration).getHelp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingsControllerApi
     */
    public getNavbarOptions(options?: any) {
        return SettingsControllerApiFp(this.configuration).getNavbarOptions(options).then((request) => request(this.axios, this.basePath));
    }
}
